const VIDEO_KEY_PREFIX = "hroAttrVideo";
const ARMED_VALUE = "armed";

const buildKey = (userId: string): string => `${VIDEO_KEY_PREFIX}:${userId}`;

/**
 * 高評価ユーザー紹介オンボーディング経由の通話到達アトリビューションを付与する
 * （userId 単位、恒久フラグ・期限なし）。オンボーディング開始直後に呼び、
 * 以降に実際の通話（直接発信・リクエスト承認いずれも）が始まったタイミングで
 * 最初の1回だけ消費される。~/utils/demoCallAttribution と同じ思想。
 */
export const armHighReviewOnboardingAttribution = (userId: string): void => {
  if (!userId) return;
  try {
    localStorage.setItem(buildKey(userId), ARMED_VALUE);
  } catch {
    // localStorage 不可: アトリビューションは付与されないが致命的ではないため無視
  }
};

/**
 * アトリビューションが armed なら消費して true を返す（一度きり）。
 */
export const takeHighReviewOnboardingAttribution = (
  userId: string,
): boolean => {
  if (!userId) return false;
  try {
    const key = buildKey(userId);
    if (localStorage.getItem(key) !== ARMED_VALUE) return false;
    localStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
};
